// Mobile-specific enhancements for touch interactions and cart functionality

document.addEventListener('DOMContentLoaded', function() {
  
  // Improve mobile cart drawer functionality
  function enhanceCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    const stickyCartIcon = document.querySelector('#sticky-cart-icon');

    if (cartDrawer && stickyCartIcon) {
      // Add touch event listeners for explicit sticky-cart drawer openers only.
      // The main header cart icon is a normal /cart link and should not be
      // hijacked by mobile enhancement code.
      [stickyCartIcon].forEach(icon => {
        if (icon) {
          icon.addEventListener('touchstart', function(e) {
            e.preventDefault();
            cartDrawer.open();
          });

          icon.addEventListener('click', function(e) {
            e.preventDefault();
            cartDrawer.open();
          });
        }
      });

      // Improve cart drawer overlay touch handling
      const overlay = cartDrawer.querySelector('.cart-drawer__overlay');
      if (overlay) {
        overlay.addEventListener('touchstart', function(e) {
          if (e.target === overlay) {
            cartDrawer.close();
          }
        });
      }

      // Fix z-index issues when cart drawer opens/closes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isActive = cartDrawer.classList.contains('active');
            const addToCartButtons = document.querySelectorAll('[name="add"], .product-form__submit');

            addToCartButtons.forEach(button => {
              if (isActive) {
                button.style.zIndex = '1';
              } else {
                button.style.zIndex = '';
              }
            });
          }
        });
      });

      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  
  // Enhance mobile menu functionality
  function enhanceMobileMenu() {
    const menuDrawer = document.querySelector('#Details-menu-drawer-container');
    const hamburgerIcon = document.querySelector('.header__icon--menu');
    
    if (menuDrawer && hamburgerIcon) {
      // Add touch support for hamburger menu
      hamburgerIcon.addEventListener('touchstart', function(e) {
        e.preventDefault();
        const isOpen = menuDrawer.hasAttribute('open');
        if (isOpen) {
          menuDrawer.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-tablet');
        } else {
          menuDrawer.setAttribute('open', '');
          document.body.classList.add('overflow-hidden-tablet');
        }
      });
      
      // Improve overlay touch handling
      const overlay = document.querySelector('.category_overlay');
      if (overlay) {
        overlay.addEventListener('touchstart', function(e) {
          menuDrawer.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-tablet');
        });
      }
    }
  }
  
  // Add to cart button enhancements for mobile
  function enhanceAddToCartButtons() {
    const addToCartButtons = document.querySelectorAll('[name="add"]');

    addToCartButtons.forEach(button => {
      // Add visual feedback for touch (but not during success state)
      button.addEventListener('touchstart', function() {
        if (!this.classList.contains('success')) {
          this.style.transform = 'scale(0.95)';
        }
      });

      button.addEventListener('touchend', function() {
        if (!this.classList.contains('success')) {
          this.style.transform = 'scale(1)';
        }
      });

      // Prevent double-tap zoom on mobile without interfering with click events
      button.addEventListener('touchend', function(e) {
        // Only prevent default if this is a double-tap (rapid successive touches)
        // Allow single taps to proceed normally to trigger click events
        if (e.detail > 1) {
          e.preventDefault();
        }
      });

      // Ensure button is always clickable on mobile
      button.style.touchAction = 'manipulation';

      // Add explicit click handler for mobile to ensure form submission works
      button.addEventListener('click', function(e) {
        // Don't interfere with the normal form submission process
        // Just ensure the button is not disabled during the click
        if (this.hasAttribute('disabled') || this.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return false;
        }
      });
    });
  }
  
  // Improve quantity input for mobile
  function enhanceQuantityInputs() {
    const quantityInputs = document.querySelectorAll('quantity-input');
    
    quantityInputs.forEach(quantityInput => {
      const buttons = quantityInput.querySelectorAll('.quantity__button');
      
      buttons.forEach(button => {
        // Add touch feedback
        button.addEventListener('touchstart', function() {
          this.style.backgroundColor = 'rgba(var(--color-foreground), 0.1)';
        });
        
        button.addEventListener('touchend', function() {
          this.style.backgroundColor = 'transparent';
        });
        
        // Prevent double-tap zoom (but not on cart elements)
        button.addEventListener('touchend', function(e) {
          // Don't prevent default on cart drawer elements
          if (!this.closest('cart-drawer') && !this.closest('.cart-drawer')) {
            e.preventDefault();
          }
        });
      });
    });
  }
  
  // Improve product card interactions on mobile
  function enhanceProductCards() {
    const productCards = document.querySelectorAll('.card-wrapper');
    
    productCards.forEach(card => {
      // Add touch feedback for product cards
      card.addEventListener('touchstart', function() {
        this.style.transform = 'scale(0.98)';
      });
      
      card.addEventListener('touchend', function() {
        this.style.transform = 'scale(1)';
      });
    });
  }
  
  // Fix viewport height for mobile browsers
  function fixMobileViewport() {
    function setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    
    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);
  }
  
  // Improve search functionality on mobile
  function enhanceSearchModal() {
    const searchButtons = document.querySelectorAll('.header__search summary');
    
    searchButtons.forEach(button => {
      button.addEventListener('touchstart', function(e) {
        e.preventDefault();
        const details = this.closest('details');
        if (details) {
          details.setAttribute('open', '');
          const input = details.querySelector('input[type="search"]');
          if (input) {
            setTimeout(() => input.focus(), 100);
          }
        }
      });
    });
  }
  
  // Initialize all mobile enhancements
  enhanceCartDrawer();
  enhanceMobileMenu();
  enhanceAddToCartButtons();
  enhanceQuantityInputs();
  enhanceProductCards();
  fixMobileViewport();
  enhanceSearchModal();
  
  // Re-initialize enhancements when new content is loaded (for AJAX)
  document.addEventListener('shopify:section:load', function() {
    enhanceCartDrawer();
    enhanceAddToCartButtons();
    enhanceQuantityInputs();
    enhanceProductCards();
  });
});

// Add CSS for mobile enhancements
const mobileCSS = `
  /* Mobile touch feedback */
  @media screen and (max-width: 989px) {
    .button:active,
    .cart__checkout-button:active,
    [name="add"]:active {
      transform: scale(0.95);
      transition: transform 0.1s ease;
    }
    
    .quantity__button:active {
      background-color: rgba(var(--color-foreground), 0.1);
    }
    
    .card-wrapper:active {
      transform: scale(0.98);
      transition: transform 0.1s ease;
    }
    
    /* Improve touch targets */
    .header__icon,
    .quantity__button,
    .drawer__close {
      min-height: 44px;
      min-width: 44px;
    }
    
    /* Better mobile cart drawer */
    .drawer__inner {
      border-radius: 20px 20px 0 0;
    }
    
    /* Mobile menu improvements */
    .menu-drawer__menu-item {
      min-height: 44px;
      display: flex;
      align-items: center;
    }
    
    /* Prevent zoom on inputs */
    input[type="text"],
    input[type="email"],
    input[type="tel"],
    input[type="number"],
    select,
    textarea {
      font-size: 16px;
    }
  }
`;

// Inject mobile CSS
const mobileStyle = document.createElement('style');
mobileStyle.textContent = mobileCSS;
document.head.appendChild(mobileStyle);
